import React from 'react';
import { IconButton, Tooltip, Box } from '@mui/material';
import { useTheme } from '../../contexts/ThemeContext';

export const DarkModeToggle: React.FC = () => {
  const { darkMode, toggleDarkMode } = useTheme();

  return (
    <Tooltip 
      title={darkMode ? 'Açık Moda Geç' : 'Karanlık Moda Geç'} 
      arrow
    >
      <IconButton
        onClick={toggleDarkMode}
        sx={{
          width: 44,
          height: 44,
          borderRadius: '12px',
          background: darkMode 
            ? 'linear-gradient(135deg, #ffd54f 0%, #ffb300 100%)'
            : 'linear-gradient(135deg, #3d4852 0%, #1a202c 100%)',
          color: darkMode ? '#1a202c' : '#ffd54f',
          boxShadow: darkMode
            ? '0 4px 15px rgba(255, 213, 79, 0.3)'
            : '0 4px 15px rgba(26, 32, 44, 0.3)',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          '&:hover': {
            transform: 'translateY(-2px) scale(1.05)',
            boxShadow: darkMode
              ? '0 6px 20px rgba(255, 213, 79, 0.4)'
              : '0 6px 20px rgba(26, 32, 44, 0.4)',
          },
          '&:active': {
            transform: 'translateY(0) scale(1)',
          }
        }}
      >
        <Box
          sx={{
            position: 'relative',
            fontSize: '18px',
            transition: 'all 0.5s ease',
            transform: darkMode ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        >
          {darkMode ? (
            <i className="fas fa-sun" />
          ) : (
            <i className="fas fa-moon" />
          )}
        </Box>
      </IconButton>
    </Tooltip>
  );
};